module.exports = {"340122100":"店埠镇","340122101":"撮镇镇","340122102":"梁园镇","340122103":"桥头集镇","340122104":"长临河镇","340122105":"石塘镇","340122106":"古城镇","340122107":"八斗镇","340122108":"元疃镇","340122109":"白龙镇","340122110":"包公镇","340122111":"陈集镇","340122200":"众兴乡","340122201":"张集乡","340122202":"马湖乡","340122204":"响导乡","340122205":"杨店乡","340122206":"牌坊回族满族乡","340122401":"肥东新城开发区","340122402":"合肥循环经济示范园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340122.json
// module id = 1040
// module chunks = 0